import type { TeamMember, TeamRole } from './api';

export const isAdminRole = (role: TeamRole | null | undefined) => {
  return role === 'OWNER' || role === 'ADMIN';
};

export const isOwnerRole = (role: TeamRole | null | undefined) => {
  return role === 'OWNER';
};

export const findCurrentTeamMembership = (members: TeamMember[], memberId: string) => {
  return members.find((member) => member.memberId === memberId);
};

export const canManageTeamMembers = (role: TeamRole | null | undefined) => {
  return isAdminRole(role);
};

export const canManageOwnerRole = (role: TeamRole | null | undefined) => {
  return isOwnerRole(role);
};

export const countAdminMembers = (members: TeamMember[]) => {
  return members.filter((member) => member.role === 'ADMIN').length;
};
